"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
var util_1 = require("util");
function jsonToQueryString(json) {
    return Object.keys(json).filter(function (key) { return json[key] !== undefined; }).map(function (key) {
        if (util_1.isArray(json[key])) {
            return encodeURIComponent(key) + '=' + JSON.stringify(json[key]);
        }
        else {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }
    }).join('&');
}
exports.AuditAPI = {
    getInventoryAudits: function (companyId, filter) {
        var url = "/api/v1/company/" + companyId + "/inventoryAudits";
        if (filter) {
            url += '?' + jsonToQueryString(filter);
        }
        return index_1.axios.get(url).then(function (response) {
            var inventoryAudits = response.data;
            return inventoryAudits;
        });
    },
    getInventoryAuditById: function (companyId, inventoryAuditId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/inventoryAudits/" + inventoryAuditId).then(function (response) {
            var inventoryAudit = response.data;
            return inventoryAudit;
        });
    },
    getAvailableAuditBatches: function (companyId, inventoryAuditId, productId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/inventoryAudits/" + inventoryAuditId + "/products/" + productId + "/batches").then(function (response) {
            var auditBatches = response.data;
            return auditBatches;
        });
    },
    getBulkAuditInventory: function (companyId, inventoryAuditId, filter) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/inventoryAudits/" + inventoryAuditId + "/bulkInventory?" + filter.queryString).then(function (response) {
            var auditProducts = response.data;
            return auditProducts;
        });
    },
    createInventoryAudit: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/inventoryAudits", createObject).then(function (response) {
            var inventoryAudit = response.data;
            return inventoryAudit;
        });
    },
    updateInventoryAudit: function (companyId, auditId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId, updateObject).then(function (response) {
            var inventoryAudit = response.data;
            return inventoryAudit;
        });
    },
    completeInventoryAudit: function (companyId, auditId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId + "/complete").then(function (response) {
            var inventoryAudit = response.data;
            return inventoryAudit;
        });
    },
    cancelInventoryAudit: function (companyId, auditId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId + "/cancel").then(function (response) {
            var inventoryAudit = response.data;
            return inventoryAudit;
        });
    },
    deleteInventoryAuditProduct: function (companyId, auditId, productId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId + "/product/" + productId);
    },
    addBatches: function (companyId, auditId, productId, batchNumbers) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId + "/product/" + productId + "/batches", batchNumbers).then(function (response) {
            return response.data;
        });
    },
    deleteInventoryAuditBatch: function (companyId, auditId, productId, batchId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/inventoryAudits/" + auditId + "/product/" + productId + "/batch/" + batchId).then(function (response) {
            var batch = response.data;
            return batch;
        });
    }
};
//# sourceMappingURL=AuditAPI.js.map